import { cn } from "@/shared/lib/cn";

interface LoadingProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

interface LoadingScreenProps {
  message?: string;
  /**
   * 外側ラッパーに追加するクラス。呼び出し側のページ背景・高さと
   * 完全に一致させたい場合(例: PC版スレッドページ)に、既定の
   * `min-h-[200px]` や背景色を上書きするために使う。
   */
  className?: string;
}

export const Loading: React.FunctionComponent<LoadingProps> = ({
  size = "md",
  className,
}: LoadingProps) => {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "block animate-spin rounded-full border-2 border-muted border-t-primary",
        size === "sm" && "w-4 h-4",
        size === "md" && "w-8 h-8",
        size === "lg" && "w-12 h-12",
        className,
      )}
    />
  );
};

export const LoadingScreen: React.FunctionComponent<LoadingScreenProps> = ({
  message = "読み込み中...",
  className,
}: LoadingScreenProps) => {
  return (
    <div
      role="status"
      className={cn(
        "flex min-h-[200px] flex-col items-center justify-center gap-3 text-muted-foreground",
        className,
      )}
      aria-live="polite"
      aria-atomic="true"
    >
      <Loading size="lg" />
      <p className="text-sm">{message}</p>
    </div>
  );
};
